import { usePlayer, trackCoverUrl } from "@/context/PlayerContext";
import { Play, Pause, SkipBack, SkipForward, SpeakerHigh, Heart } from "@phosphor-icons/react";

const fmt = (s) => {
  if (!s || isNaN(s)) return "0:00";
  const m = Math.floor(s / 60);
  const sec = Math.floor(s % 60);
  return `${m}:${sec.toString().padStart(2, "0")}`;
};

export default function MiniPlayer() {
  const p = usePlayer();
  if (!p?.current) return null;

  const cover = trackCoverUrl(p.current);
  return (
    <div
      data-testid="mini-player"
      className="fixed bottom-0 left-0 right-0 z-50"
      style={{
        backdropFilter: "blur(24px)",
        WebkitBackdropFilter: "blur(24px)",
        background: "rgba(5,5,5,0.82)",
        borderTop: "1px solid rgba(255,255,255,0.08)",
      }}
    >
      <div
        className="h-[2px] bg-neutral-800 cursor-pointer"
        onClick={(e) => {
          const rect = e.currentTarget.getBoundingClientRect();
          p.seek(((e.clientX - rect.left) / rect.width) * 100);
        }}
        data-testid="player-progress-bar"
      >
        <div className="h-full bg-red-600" style={{ width: `${p.progress}%` }} />
      </div>
      <div className="flex items-center gap-5 px-4 md:px-8 py-3">
        <div className="flex items-center gap-3 min-w-0 flex-1">
          {cover ? (
            <img src={cover} alt="" className="w-12 h-12 object-cover" />
          ) : (
            <div className="w-12 h-12 bg-neutral-900 border border-neutral-800" />
          )}
          <div className="min-w-0">
            <div className="font-display text-sm font-bold truncate" data-testid="player-track-title">{p.current.title}</div>
            <div className="font-mono-ui text-[11px] uppercase tracking-widest text-neutral-400 truncate">{p.current.artist_name}</div>
          </div>
        </div>

        <div className="flex items-center gap-4">
          <button className="hover:text-red-500 transition-colors" onClick={p.prev} data-testid="player-prev-btn">
            <SkipBack size={20} weight="fill" />
          </button>
          <button
            onClick={p.toggle}
            className="w-11 h-11 rounded-full bg-white text-black flex items-center justify-center hover:scale-105 transition-transform"
            data-testid="player-toggle-btn"
          >
            {p.playing ? <Pause size={18} weight="fill" /> : <Play size={18} weight="fill" />}
          </button>
          <button className="hover:text-red-500 transition-colors" onClick={p.next} data-testid="player-next-btn">
            <SkipForward size={20} weight="fill" />
          </button>
        </div>

        <div className="hidden md:flex items-center gap-3 flex-1 justify-end">
          <span className="font-mono-ui text-[11px] text-neutral-400 tabular-nums">
            {fmt((p.progress / 100) * p.duration)} / {fmt(p.duration)}
          </span>
          <SpeakerHigh size={18} className="text-neutral-400" />
          <input
            type="range" min={0} max={1} step={0.01} value={p.volume}
            onChange={(e) => p.setVolume(parseFloat(e.target.value))}
            className="w-24 accent-red-600"
            data-testid="player-volume"
          />
        </div>
      </div>
    </div>
  );
}
